import { Pipe, PipeTransform } from '@angular/core';
import { isMajorSectionBreak, isNumberedSectionHeading } from '../utils/soap-section-format.util';

/**
 * Converts lines like `1. Heading` into `• Heading` (preserving indentation).
 * Left-aligns all lines for display (no extra indentation).
 * Intended for display-only formatting.
 */
@Pipe({
  name: 'bulletizeNumberedHeadings',
  standalone: true,
  pure: true
})
export class BulletizeNumberedHeadingsPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    // Replace "1. " style headings with bullets.
    // Guardrail: only 1-2 digit prefixes (avoid years like "2018. ").
    const withBullets = value.replace(/^\s*\d{1,2}\.\s+/gm, '• ');

    // Left-align all non-empty lines and ensure spacing between sub-categories.
    const lines = withBullets.replace(/\r/g, '').split('\n');
    const out: string[] = [];

    for (const line of lines) {
      const normalized = line.trim() === '' ? '' : line.trimStart();

      if (normalized.startsWith('• ') && this.isTopLevelSectionLine(normalized)) {
        const last = out.length > 0 ? out[out.length - 1] : null;
        if (last !== null && last !== '') {
          out.push('');
        }
        out.push(normalized);
        continue;
      }

      if (normalized.startsWith('• ')) {
        out.push(normalized);
        continue;
      }

      out.push(normalized);
    }

    return out.join('\n');
  }

  /** Blank-line separation only between section headers, not list items. */
  private isTopLevelSectionLine(line: string): boolean {
    if (isNumberedSectionHeading(line)) {
      return true;
    }
    return isMajorSectionBreak(line);
  }
}

